import { render } from "./BaseModalConteiner.vue?vue&type=template&id=58bf7300&scoped=true"
import script from "./BaseModalConteiner.vue?vue&type=script&lang=js"
export * from "./BaseModalConteiner.vue?vue&type=script&lang=js"

import "./BaseModalConteiner.vue?vue&type=style&index=0&id=58bf7300&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bf7300"]])

export default __exports__